import React from 'react';
import WidgetContextMenu from './widget-context-menu';

export default function OnlineTicketingContextMenu({ organization, ticket_shop }) {
    return (
        <WidgetContextMenu
            context={ticket_shop}
            usages={['sale', 'resale', 'multi_events']}
            organization={organization}
            footerCtaLabel="ticket.online_ticketing.menu.footer_cta"
            goBackLabel="ticket.online_ticketing.menu.go_back"
        />
    );
}
